import ConfirmPopover from '@/components/common/ConfirmPopover';
import IconButton from '@/components/common/IconButton';
import { useApplication } from '@/hooks/useApplication';
import { Signal } from '@/types/signal';
import { findSubroutine } from '@/util/application';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import { Box, ListItem, ListItemText } from '@mui/material';
import { FC, useState } from 'react';
import SignalListItemEdit from './SignalListItemEdit';

type SignalListItemProps = {
  signal: Signal;
  onSave?: (newSignal: Signal) => void;
  onDelete?: () => void;
};

const SignalListItem: FC<SignalListItemProps> = (props) => {
  const { application } = useApplication();
  const [openEdit, setOpenEdit] = useState(props.signal && !props.signal.name);
  return (
    <ListItem sx={{ gap: 1, pt: 0, pb: 0 }}>
      {openEdit ? (
        <SignalListItemEdit
          signal={props.signal}
          onClose={(isEmpty) => {
            setOpenEdit(false);
            if (isEmpty) {
              props.onDelete && props.onDelete();
            }
          }}
          onSave={(newSignal) => {
            props.onSave && props.onSave(newSignal);
          }}
        />
      ) : (
        <>
          <code>{props.signal.id}</code>
          <ListItemText primary={props.signal.name} secondary={props.signal.description} />
          <code>
            {props.signal.substart >= 0 && findSubroutine(application.subroutines, props.signal.substart)?.label}
          </code>
          <Box>
            <IconButton
              tooltip='Edit'
              onClick={() => {
                setOpenEdit(true);
              }}
            >
              <EditIcon />
            </IconButton>
            <ConfirmPopover
              text={
                <>
                  Delete <code>{props.signal.name}</code>?
                </>
              }
              onConfirm={() => props.onDelete && props.onDelete()}
              skipConfirm={!props.signal.name}
              icon={<ClearIcon />}
            />
          </Box>
        </>
      )}
    </ListItem>
  );
};

export default SignalListItem;
